import { useMutation } from '@tanstack/react-query';
import { postCutOfWarrantyBulk } from '../../../resources/payload';
import { openAlert } from '../../../components/alert/hooks';
import { POST, POST_SUBMIT_CUT_OF_WARRANTY } from '../../../services';

export const useUpdateCutOfWarranty = () =>
  useMutation({
    mutationFn: async (values) => {
      const payload = values.map((item) => postCutOfWarrantyBulk(item));

      const response = await POST(POST_SUBMIT_CUT_OF_WARRANTY(), payload);
      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'บันทึกข้อมูลสำเร็จ',
      });
    },
    onError: (err) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: err?.message || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล',
      });
    },
  });
